import type { Props } from './Svg'
import { Svg } from './Svg'

export function PencilIcon(props: Props) {
  return (
    <Svg width="16" height="16" fill="currentColor" stroke="none" {...props}>
      <path d="M12.996 0c-.4 0-.79.145-1.083.44L1.483 10.868l-1.465 4.07C-.097 15.483.358 16 .891 16a.767.767 0 0 0 .17-.018l4.07-1.464 10.43-10.43c.62-.62.578-1.668-.093-2.34L14.252.532A1.783 1.783 0 0 0 12.996 0Zm.04 1.748 1.216 1.216L4.187 13.03l-1.9.684.684-1.9L13.036 1.748Z" />
    </Svg>
  )
}
